import { Signal, SignalHigh, SignalLow, SignalMedium } from 'lucide-react';

export default function SignalIcon({ probability }: { probability: number }) {
  if (probability < 35) return <SignalLow className="size-4 text-amber-500" />;

  if (probability < 55)
    return (
      <SignalMedium className="size-4 text-yellow-400 dark:text-yellow-300" />
    );

  if (probability < 75) return <SignalHigh className="size-4 text-lime-400" />;

  return <Signal className="size-4 text-green-500" />;
}
